<template>
  <div id="aspectwrapper" class="aspectwrapper" @mousemove="resetTimer" @touchstart="resetTimer">
    <img v-if="this.currentVideoBatch.watermark" :src="this.currentVideoBatch.watermark" class="water-mark" />
    <div class="content" id="content">
      <div class="video-component" id="video-part">

      </div>
      <div v-show="showUI" class="fullscreen-image" id="hotspots">
      </div>
    </div>
    <div id="texts">
    </div>
    <div v-show="notInTransition" class="navigation-buttons" id="navigation-buttons">
      <div class="navigation-button" @click="onHomeButtonClick">
        <input v-show="navigationButtons.home.show" id="home-button" type="image" class="navigation-button-icon"
          :src="homeButtonIcon">
      </div>
      <div class="navigation-button" @click="onBackButtonClick">
        <input v-show="navigationButtons.back.show" id="back-button" type="image" class="navigation-button-icon"
          :src="backButtonIcon">
      </div>
      <div class="navigation-button" :class="navigationButtons.uiToogle.class" @click="toogleUIVisibility()">
        <input v-show="navigationButtons.back.show" id="ui-toogle-button" type="image" class="navigation-button-icon"
          :src="uiToogleButtonIcon">
      </div>
    </div>
  </div>
</template>
<script>

const publicPath = process.env.BASE_URL;
const MAIN_VIDEO_ID = 'main-video';

export default {
  name: 'SeamlessVideoPageComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    videoBatches: {
      type: Array,
      required: true,
      default: []
    },
    fadeTime: {
      type: Number,
      default: 0
    },
    homeButtonIcon: {
      type: String,
      default: require('../assets/home_blue.png')
    },
    backButtonIcon: {
      type: String,
      default: require('../assets/back_blue.png')
    },
    hotspotIcon: {
      type: String,
      default: ''
    },
    fontFamily: {
      type: String,
      default: 'Calibri'
    },
    uiToogleButtonIcon: {
      type: String,
      default: require('../assets/back_blue.png')
    },
  },
  data() {
    return {
      timeouts: [],
      fadeVideoTimeout: null,
      watermark: "",
      showButtons: false,
      currentVideoBatch: null,
      namedVideoBatches: [],
      hotspots: [],
      idleTimeout: null,
      zIndex: 10,
      showUI: true,
      fadeOutWarmUpTime: 0.1,
      notInTransition: true,
      navigationButtons: {
        home: {
          show: true,
          element: null,
          videoBatch: null
        },
        back: {
          show: true,
          element: null,
          videoBatch: null
        },
        uiToogle: {
          show: true,
          element: null,
          class: ''
        }
      }
    }
  },
  created() {
    this.createFadeStyle(this.fadeTime);
    this.currentVideoBatch = this.videoBatches[0];
    window.addEventListener('resize', this.onWindowResize);
    setTimeout(() => {
      this.onWindowResize();
    }, 250);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  mounted() {
    for (let x = 0; x < this.videoBatches.length; x++) {
      let videoBatch = this.videoBatches[x];
      this.namedVideoBatches[videoBatch.key] = videoBatch;
    }

    const video = this.createNewVideoTag({
      videoPreload: this.currentVideoBatch.videoPath,
      nextVideoBatch: MAIN_VIDEO_ID
    });

    document.getElementById('video-part').appendChild(video);

    this.processVideoActions(this.currentVideoBatch.actions);
    this.setupNextVideo(video, this.currentVideoBatch.loop);

    video.play();
  },
  methods: {
    createFadeStyle(fadeTime) {
      let style = document.createElement('style');
      style.innerHTML = `
        @keyframes fadeOut {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
        .fade-out {
          animation: fadeOut ${fadeTime}s forwards;
        }
      `;
      document.head.appendChild(style);
    },
    promoteNextBatch(batchName) {
      const currentVideo = document.getElementById(MAIN_VIDEO_ID);
      const buttonPart = document.getElementById('hotspots');
      const nextVideo = document.getElementById(batchName);

      buttonPart.innerHTML = '';
      this.timeouts.forEach((timeout) => clearTimeout(timeout));
      this.timeouts = [];
      this.hotspots = [];

      this.setupNextVideo(nextVideo, this.namedVideoBatches[batchName].loop);
      nextVideo.play();
      this.notInTransition = false;

      this.fadeOutVideo(nextVideo, currentVideo).then(() => {
        this.replaceVideoBatch(batchName);
      });
    },
    setupNextVideo(nextVideo, loop) {
      const fadeInVideo = document.getElementById(MAIN_VIDEO_ID + '-fade-in');
      if (fadeInVideo) fadeInVideo.remove();

      nextVideo.currentTime = 0;
      nextVideo.style.display = "block";

      if (this.fadeTime <= 0 && loop) {
        nextVideo.loop = true;
        return;
      } else if (this.fadeTime <= 0) {
        nextVideo.addEventListener('ended', () => this.onVideoFinished(nextVideo), false);
      } else {
        const onPlayEvent = () => {
          console.debug('Video started', nextVideo);
          const fadeOutStartTime = Math.max(0, (nextVideo.duration - this.fadeTime) * 1000);
          if (this.fadeVideoTimeout) clearTimeout(this.fadeVideoTimeout);
          this.fadeVideoTimeout = setTimeout(() => this.onVideoFinished(nextVideo), fadeOutStartTime);
        };

        if (!nextVideo.duration) {
          console.debug('Video duration not available, waiting for metadata');
          nextVideo.addEventListener('loadedmetadata', () => {
            nextVideo.addEventListener('play', onPlayEvent)
          });
        } else {
          console.debug('Video duration available');
          nextVideo.addEventListener('play', onPlayEvent);
        }

        if (!loop) return;

        let fadeInVideo = nextVideo.cloneNode(true);
        fadeInVideo.classList.add('fullscreen-video');
        fadeInVideo.style.display = "none";
        fadeInVideo.id = MAIN_VIDEO_ID + '-fade-in';
        fadeInVideo.muted = true;
        fadeInVideo.autoplay = true;
        fadeInVideo.currentTime = 0;
        fadeInVideo.style.zIndex--;
        nextVideo.parentNode.appendChild(fadeInVideo);
      }
    },
    replaceVideoBatch(batchName) {
      const currentVideo = document.getElementById(MAIN_VIDEO_ID);
      const nextBatch = this.namedVideoBatches[batchName];
      const nextVideo = document.getElementById(batchName);
      const videoPart = document.getElementById('video-part');

      currentVideo.remove();
      nextVideo.id = MAIN_VIDEO_ID;
      videoPart.childNodes.forEach(function (child) {
        if (child.id.indexOf(MAIN_VIDEO_ID) === -1) {
          videoPart.removeChild(child);
        }
      });

      this.processVideoActions(nextBatch.actions);
      this.currentVideoBatch = nextBatch;
    },
    processVideoActions(actions) {
      const videoPart = document.getElementById('video-part');
      if (!videoPart) return;
      this.navigationButtons.home.videoBatch = null;
      this.navigationButtons.back.videoBatch = null;
      for (let x = 0; x < actions.length; x++) {
        if (!actions[x].actionType) continue;
        if (actions[x].actionType !== 'ShowText') {
          let video = this.createNewVideoTag(actions[x]);
          videoPart.appendChild(video);
          video.pause();
        }
        this.setActionTimeout(actions[x]);
      }
    },
    setActionTimeout(action) {
      if (action.actionType === "Button" && action.actionParams) {
        this.timeouts.push(setTimeout(() => this.createHotspots(action, action.actionType), action.actionParams.timeToShow));
      } else if (action.actionType === "ButtonBack" && action.actionParams) {
        this.timeouts.push(setTimeout(() => this.setBackVideoBatch(action.nextVideoBatch), action.actionParams.timeToShow));
      } else if (action.actionType === "ButtonHome" && action.actionParams) {
        this.timeouts.push(setTimeout(() => this.setHomeVideoBatch(action.nextVideoBatch), action.actionParams.timeToShow));
      } else if (action.actionType === "ShowText" && action.actionParams) {
        this.timeouts.push(setTimeout(() => this.createText(action.actionParams, action.actionParams.duration), action.actionParams.timeToShow));
      } else if (action.actionType === "HotSpot" && action.actionParams) {
        this.timeouts.push(setTimeout(() => this.createHotSpot(action.actionParams, action.nextVideoBatch), action.actionParams.timeToShow));
      }
    },
    createNewVideoTag(item) {
      const newVideo = document.createElement('video');
      const newSource = document.createElement('source');
      newVideo.controls = false;
      newVideo.muted = true;
      newVideo.autoplay = true;
      newSource.src = publicPath + item.videoPreload;
      newSource.type = "video/mp4";
      newVideo.appendChild(newSource);
      newVideo.id = item.nextVideoBatch;
      newVideo.key = item.nextVideoBatch;
      newVideo.classList.add('fullscreen-video');
      newVideo.style.display = 'none';
      newVideo.style.zIndex = this.zIndex--;

      return newVideo;
    },
    setBackVideoBatch(backVideoBatch) {
      this.navigationButtons.back.videoBatch = backVideoBatch;
    },
    setHomeVideoBatch(homeVideoBatch) {
      this.navigationButtons.home.videoBatch = homeVideoBatch;
    },
    createText(params, duration) {
      const parent = document.getElementById('hotspots');
      const infoArea = document.createElement('div');
      infoArea.classList.add('info-area');
      this.placeInfoArea(infoArea, params.coords);
      const title = document.createElement('div');
      title.classList.add('t1');
      title.style.fontFamily = this.fontFamily;
      title.innerHTML = params.title;
      const subtitle = document.createElement('div');
      subtitle.classList.add('t2');
      subtitle.style.fontFamily = this.fontFamily;
      subtitle.innerHTML = params.subtitle;
      const description = document.createElement('p');
      description.classList.add('description');
      description.style.fontFamily = this.fontFamily;
      description.innerHTML = params.text.replace(/\n/g, "<br />");
      infoArea.appendChild(title);
      infoArea.appendChild(subtitle);
      infoArea.appendChild(description);
      parent.appendChild(infoArea);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          infoArea.classList.add('infoArea-fade-in');
        });
      });

      if (duration) {
        this.timeouts.push(setTimeout(() => {
          infoArea.classList.remove('infoArea-fade-in');
          infoArea.classList.add('infoArea-fade-out');
          infoArea.addEventListener('transitionend', () => {
            infoArea.remove();
          });
        }, duration));
      }
    },
    createNavigationButton(item, actionType) {
      const hotspots = document.getElementById('hotspots');
      const newCoordsArray = item.actionParams.coords.split(',');
      const newButton = document.createElement('input');

      newButton.type = "image";
      newButton.src = require("@/assets/Circles_1.gif");
      newButton.style.width = "100px";
      newButton.style.mixBlendMode = "plus-lighter"
      newButton.style.zIndex = hotspots.style.zIndex + 10;
      newButton.style.cursor = 'pointer';
      newButton.style.position = 'absolute';
      newButton.style.left = newCoordsArray[0] + "vw";
      newButton.style.top = newCoordsArray[1] + "vw";
      newButton.style.transform = "translate(-50%, -50%)";
      hotspots.appendChild(newButton);

      newButton.dataset.nextVideoBatch = item.nextVideoBatch;
      newButton.addEventListener('click', this.onLoadBatchButtonClick);
    },
    createHotSpot(actionParams, nextVideoBatch) {
      const hotspots = document.getElementById('hotspots');
      const newCoordsArray = actionParams.coords.split(',');
      const newButton = document.createElement(this.hotspotIcon ? 'input' : 'div');
      newButton.dataset.nextVideoBatch = nextVideoBatch;
      newButton.classList.add('hotspot');
      newButton.style.zIndex = hotspots.style.zIndex + 10;
      newButton.style.position = 'absolute';
      newButton.style.left = newCoordsArray[0] + "vw";
      newButton.style.top = newCoordsArray[1] + "vw";
      if (this.hotspotIcon) {
        newButton.classList.add('hotspotButton');
        newButton.type = "image";
        newButton.src = this.hotspotIcon;
      } else {
        newButton.classList.add('hotspotButton-circle');
      }
      newButton.style.cursor = 'pointer';
      newButton.addEventListener('click', this.onLoadBatchButtonClick);
      hotspots.appendChild(newButton);
      this.hotspots.push(newButton);

      const btnText = document.createElement('div');
      btnText.style.cursor = 'pointer';
      btnText.style.position = 'absolute';
      btnText.style.left = newCoordsArray[0] + "vw";
      btnText.style.top = newCoordsArray[1] + "vw";
      btnText.style.fontFamily = this.fontFamily;
      btnText.classList.add('hotspot');
      btnText.classList.add(`hotspotText`);
      btnText.style.transform = actionParams.position;
      btnText.innerHTML = actionParams.text;
      btnText.dataset.nextVideoBatch = nextVideoBatch;
      btnText.style.zIndex = hotspots.style.zIndex + 10;
      btnText.addEventListener('click', this.onLoadBatchButtonClick);
      btnText.addEventListener('mouseover', function () { this.style.backgroundColor = "#000000aa"; });
      btnText.addEventListener('mouseout', function () { this.style.backgroundColor = "#00000055"; });
      hotspots.appendChild(btnText);

      this.connectHotspots(newButton, btnText, hotspots);
      this.hotspots.push(newButton);
    },
    onLoadBatchButtonClick(event) {
      const nextVideoBatch = event.target.dataset.nextVideoBatch;
      this.promoteNextBatch(nextVideoBatch);
    },
    onHomeButtonClick() {
      if (!this.navigationButtons.home.videoBatch) return;
      this.promoteNextBatch(this.navigationButtons.home.videoBatch);
    },
    onBackButtonClick() {
      if (!this.navigationButtons.home.videoBatch) return;
      this.promoteNextBatch(this.navigationButtons.back.videoBatch);
    },
    calculateCoords(coords) {
      const div = document.getElementById('content');
      let newCoords = '';
      const coordsArray = coords.split(',');
      for (let x = 0; x < coordsArray.length; x += 2) {
        let coord = Math.round((coordsArray[x] * div.clientWidth) / 1920);
        newCoords += coord + ',';
        coord = Math.round((coordsArray[x + 1] * div.clientHeight) / 1080);
        newCoords += coord + ',';
      }
      return newCoords.slice(0, -1);
    },
    onVideoFinished(video) {
      if (video.id !== MAIN_VIDEO_ID) return;
      console.debug('Video finished', video);
      const nextVideo = document.getElementById(this.currentVideoBatch.actions[0].nextVideoBatch);

      if (this.currentVideoBatch.loop) {
        const currentVideo = document.getElementById(MAIN_VIDEO_ID);
        const fadeInVideo = document.getElementById(MAIN_VIDEO_ID + '-fade-in');
        currentVideo.id = 'main-video-fade-out';
        fadeInVideo.id = MAIN_VIDEO_ID;
        this.setupNextVideo(fadeInVideo, true);
        fadeInVideo.play();
        this.fadeOutVideo(fadeInVideo, currentVideo).then(() => {
          console.debug('Fade out finished', currentVideo);
          currentVideo.remove();
        });

        return;
      } else if (nextVideo && this.currentVideoBatch.actions[0].actionType === 'PlayWhenEnded') {
        this.promoteNextBatch(this.currentVideoBatch.actions[0].nextVideoBatch);
      } else if (this.screensaver && this.screensaver == true) {
        this.$router.push('/screensaver')
      }
      this.notInTransition = true;

    },
    fadeOutVideo(inVideo, outVideo) {
      return new Promise((resolve, reject) => {
        inVideo.style.display = "block";
        outVideo.classList.add('fade-out');
        outVideo.addEventListener('animationend', function () {
          resolve();
        });
      });
    },
    toogleUIVisibility() {
      this.showUI = !this.showUI;
      if (this.showUI) {
        this.navigationButtons.uiToogle.class = '';
      } else {
        this.navigationButtons.uiToogle.class = 'navigation-button-selected';
      }
    },
    placeInfoArea(infoArea, coords) {
      if (!coords) {
        infoArea.style.right = '0px';
        infoArea.style.top = '50px';
        return;
      }

      const coordsObj = coords.split(',').reduce((acc, curr, idx) => {
        if (idx === 0) acc.left = curr.trim();
        if (idx === 1) {
          if (parseFloat(curr) >= 0) {
            acc.top = curr.trim();
          } else {
            acc.bottom = Math.abs(parseFloat(curr)) + 'px';
          }
        }
        return acc;
      }, {});

      if (coordsObj.left) {
        infoArea.style.left = coordsObj.left.includes('%') || coordsObj.left.includes('px')
          ? coordsObj.left
          : coordsObj.left + 'px';
      }

      if (coordsObj.top) {
        infoArea.style.top = coordsObj.top.includes('%') || coordsObj.top.includes('px')
          ? coordsObj.top
          : coordsObj.top + 'px';
      }

      if (coordsObj.bottom) {
        infoArea.style.bottom = coordsObj.bottom;
      }
    },
    connectHotspots(spot, text, container) {
      const rect1 = spot.getBoundingClientRect();
      const x1 = rect1.left + rect1.width / 2;
      const y1 = rect1.top + rect1.height / 2;

      const coords = this.getMinHotspotTextCoordinates(spot, text);
      const angle = Math.atan2(coords.y - y1, coords.x - x1) * 180 / Math.PI;

      const line = document.createElement("div");
      line.className = "hotspot-line";
      line.style.width = coords.distance + "px";
      line.style.transform = `rotate(${angle}deg)`;
      line.style.left = x1 + "px";
      line.style.top = y1 + "px";

      if (container) container.appendChild(line);
      else document.body.appendChild(line);
    },
    getMinHotspotTextCoordinates(spot, text) {
      const rect1 = spot.getBoundingClientRect();
      const rect2 = text.getBoundingClientRect();

      const spotIsAvobeText = rect1.bottom < rect2.top;
      const spotIsBelowText = rect1.top > rect2.bottom;
      const spotIsLeftOfText = rect1.right < rect2.left + rect2.width / 2;
      const spotIsRightOfText = rect1.left > rect2.right + rect2.width / 2;

      const x1 = rect1.left + rect1.width / 2;
      const y1 = rect1.top + rect1.height / 2;

      let yOffset = 6.5;
      let xOffset = -1;
      if (spotIsBelowText && spotIsRightOfText) {
        xOffset = 1;
        yOffset = 7;
      } else if (spotIsAvobeText && spotIsRightOfText) {
        xOffset = -1;
        yOffset = 8.5;
      }

      const bottomLeft = {
        x: rect2.left + (spotIsBelowText && spotIsLeftOfText ? 0 : 2.5),
        y: rect2.bottom + 5.5
      };
      const bottomRight = {
        x: rect2.right + xOffset,
        y: rect2.bottom + yOffset
      };

      const distances = [
        Math.sqrt((bottomLeft.x - x1) ** 2 + (bottomLeft.y - y1) ** 2),
        Math.sqrt((bottomRight.x - x1) ** 2 + (bottomRight.y - y1) ** 2),
      ];

      const minDistance = Math.min(...distances);
      const minDistanceIndex = distances.indexOf(minDistance);

      switch (minDistanceIndex) {
        case 0:
          return { ...bottomLeft, distance: minDistance };
        case 1:
          return { ...bottomRight, distance: minDistance };
      }
    },
    clearLines() {
      document.querySelectorAll('.hotspot-line').forEach(line => line.remove());
    },
    onWindowResize() {
      const arWrapperRect = document.getElementById('aspectwrapper').getBoundingClientRect();
      const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      const buttons = document.getElementById('navigation-buttons');
      buttons.style.bottom = (Math.max(0, viewportHeight - arWrapperRect.height) + 20) + 'px';

      this.clearLines();
      for (let i = 0; i < this.hotspots.length; i++) {
        const spot = this.hotspots[i];
        const text = spot.nextSibling;
        if (!text) continue;

        this.connectHotspots(spot, text, document.getElementById('hotspots'));
      }
    },
  }
}
</script>

<style>
.aspectwrapper {
  display: inline-block;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 56.25vw;
  overflow: hidden;
}

.aspectwrapper::after {
  padding-top: 56.25%;
  display: block;
  content: '';
}

.content {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.video-component {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 56.25vw;
  overflow: hidden;
}

.fullscreen-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  height: 56.25vw;
  z-index: 1;
}

.fullscreen-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 56.25vw;
  z-index: 100;
}

.image-map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 56.25vw;
  z-index: 11;
}

body {
  overflow: hidden;
  background-color: #000000;
}

.navigation-buttons {
  background-color: #00000055;
  position: fixed;
  display: inline-flex;
  align-items: center;
  z-index: 110;
  bottom: 20px;
  right: 30px;
  max-width: 150px;
  object-fit: scale-down;
}

.navigation-button {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  z-index: 13;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.navigation-button-selected {
  background-color: #00000080;
}

.navigation-button-icon {
  position: relative;
  z-index: 13;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.navigation-button:hover {
  background-color: #000000aa;
}

.info-area {
  opacity: 0;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.35);
  text-align: center;
  z-index: 11;
  padding: 15px;
  width: 350px;
  overflow-y: auto;
  box-shadow: -10px 0px 10px 0px rgba(0, 0, 0, 0.4);
}

.info-area .t1 {
  color: #FFF;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.5em;
  position: relative;
  margin-top: 10px;
}

.info-area .t2 {
  color: #FFF;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.5em;
  position: relative;
}

.info-area .description {
  color: #FFF;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.5em;
  position: relative;
}

.hotspot {
  border-radius: 3px;
}

.hotspotButton {
  width: 40px;
  height: 40px;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.hotspotButton-circle {
  background-color: #fff;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  transform: translate(-50%, -50%);
}

.hotspotText {
  color: white;
  background-color: #00000055;
  padding: 5px 30px 5px 30px;
  border-radius: 6px;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  position: relative;
}

.hotspotText::before {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 3px;
  background-color: white;
}

.hotspot-line {
  position: absolute;
  background: white;
  height: 3px;
  width: 3px;
  border-radius: 3px;
  transform-origin: top left;
}

.hotspotText-circle-left::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
}

.hotspotText-circle-right::after {
  content: "";
  position: absolute;
  bottom: -10px;
  right: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
}

.infoArea-fade-in {
  opacity: 1 !important;
  transition: opacity 0.35s;
}

.infoArea-fade-out {
  opacity: 0 !important;
  transition: opacity 1s;
}

.water-mark {
  position: absolute;
  top: 0;
  left: 30;
  width: 15%;
  z-index: 1000;
  opacity: 0.6;
}
</style>
